module.exports = __webpack_public_path__ + "img/bed-4.6fcc1942.svg";